import React, {useEffect, useRef} from "react";
const useMutationObserver = (
    ref,
    callback,
    options = {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    }
) => {
    const observerRef = useRef(null);
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (ref.current) {
            const observer = new window.MutationObserver(callback);
            observerRef.current = observer;
            observer.observe(ref.current, options);
            return () => observer.disconnect();
        }
    }, [callback, options, ref]);

    return observerRef;
};

export default useMutationObserver;
